import { Capitalize, formatDateAndTime, iaRa } from 'lib/helpers/utility';

import { PATIENT_OPTIONS, TAG_FAX_OPTIONS } from 'components/shared/Filters/lib/filterOptions';
import TagsCell from 'components/shared/Tags/components/Cell/TagsCell';

import DateHeader from '../../DateHeader';
import { normalizePhone } from '../../components/SendFax/lib';
import DraftActions from '../components/DraftActions';

import { NameCell } from './NameCell';

export const getColDefs = ({ timezone }) => [
  {
    field: 'id',
    headerName: 'ID',
    maxWidth: 120
  },
  {
    field: 'name',
    headerName: 'Name',
    cellRenderer: NameCell
  },
  {
    field: 'subject',
    headerName: 'Title',
    valueGetter: (params) => {
      if (!!params?.node?.group) {
        return '';
      }
      const faxTitle = params?.data?.subject || 'N/A';
      return faxTitle;
    }
  },
  {
    field: 'fax_caller_id',
    headerName: 'Fax Num',
    valueGetter: (params) => {
      if (!!params?.node?.group) {
        return '';
      }
      const fax = params?.data;
      return normalizePhone(fax?.fax_caller_id, true) || '';
    }
  },
  {
    field: 'deliver_to',
    headerName: 'Deliver To',
    valueGetter: (params) => {
      if (!!params?.node?.group) {
        return '';
      }
      const fax = params?.data;

      return fax?.deliver_to;
    }
  },
  {
    field: 'notes',
    headerName: 'Note',
    valueGetter: (params) => {
      if (!!params?.node?.group) {
        return '';
      }
      const fax = params?.data;

      return fax?.notes;
    }
  },
  {
    field: 'created_at',
    headerName: 'Date',
    valueGetter: (params) => {
      if (!!params?.node?.group) {
        return '';
      }
      const created_at = params?.data?.created_at;
      return formatDateAndTime(created_at, timezone);
    },
    headerComponent: DateHeader
  },
  {
    field: 'patient_name',
    headerName: 'Patient',
    valueGetter: (params) => {
      if (!!params?.node?.group) {
        return '';
      }
      const name = params?.data?.assignedTo?.fullName || 'Not assigned';
      return name;
    }
  },
  {
    field: 'document_sign',
    headerName: 'Assigned to',
    valueGetter: (params) => {
      if (!!params?.node?.group) {
        return '';
      }
      const fax = params?.data;
      return (
        iaRa(fax?.document_sign)
          ?.map((sign) => `${sign.user.f_name} ${sign.user.l_name}`)
          .join(', ') || 'Not assigned'
      );
    }
  },
  {
    field: 'state',
    headerName: 'Status',
    valueFormatter: ({ value }) => Capitalize(value)
  },
  {
    field: 'createdBy',
    headerName: 'Created By',
    valueGetter: (params) => {
      const createdBy = params?.data?.createdBy;
      return createdBy ? `${createdBy?.f_name} ${createdBy?.l_name}` : '-';
    }
  },
  {
    field: 'tagLinks',
    headerName: 'Tags',
    sortable: false,
    cellRenderer: ({ value, data }) => (
      <TagsCell
        value={value}
        data={data}
        refTable="fax"
        kind="fax"
        query={{ keys: ['draftFaxes'], object: 'draftFaxes' }}
      />
    ),
    minWidth: 300
  },
  {
    field: 'actions',
    headerName: 'Actions',
    cellRenderer: DraftActions,
    maxWidth: 88,
    minWidth: 36,
    resizable: false,
    sortable: false,
    pinned: 'right'
  }
];

export const DEFAULT_COLUMN_DEFS = {
  enableRowGroup: true
};

export const GRID_OPTIONS = {
  animateRows: true,
  rowGroupPanelShow: 'always',
  enableRangeSelection: true,
  showOpenedGroup: true,
  suppressAggFuncInHeader: true,
  autoGroupColumnDef: {
    pinned: 'left',
    sortable: false
  }
};

export const DEFAULT_FILTERS = {
  date: {
    type: 'date-range',
    title: 'Date',
    icon: 'calendar-mono'
  },
  id: {
    title: 'ID',
    placeholder: 'Search ID',
    allowed_operators: ['contains', 'does not contain'],
    icon: 'text-num-mono'
  },
  name: {
    title: 'Name',
    allowed_operators: ['contains', 'does not contain'],
    icon: 'user-2-mono'
  },
  title: {
    title: 'Title',
    allowed_operators: ['contains', 'does not contain'],
    icon: 'editor-text-mono'
  },
  faxNum: {
    title: 'Fax Number',
    allowed_operators: ['contains', 'does not contain'],
    icon: 'text-num-mono'
  },

  deliver_to: {
    title: 'Deliver To',
    allowed_operators: ['contains', 'does not contain'],
    icon: 'user-2-mono'
  },

  note: {
    title: 'Note',
    allowed_operators: ['contains', 'does not contain'],
    icon: 'editor-text-mono'
  },
  patients: PATIENT_OPTIONS,
  tags: TAG_FAX_OPTIONS
};
